import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "fwdRef"];
import React, { forwardRef } from 'react';
import { buildVersionedClassNames } from '@op/opds.opux-utilities';

/**
 * A convenience wrapper that applies appropriate margins to content in tiles
 * that set `wrapContent={false}`. Forwards ref to the underlying `div` element.
 *
 * See the [Tile guidelines](#/Layout%20%26%20Structure/Tile) for example usage.
 */
export const TileContent = _ref => {
  let {
      children,
      className,
      fwdRef
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: buildVersionedClassNames('ds-tile__content', className),
    ref: fwdRef
  }, otherProps), children);
};
const Fwd = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(TileContent, _extends({}, props, {
  fwdRef: ref
})));
Fwd.displayName = 'TileContent';
export default Fwd;